import { ENV } from '../types';

/**
 * Check if the current environment is one of the given environments
 * @param envs - The environments to check against
 * @returns True if the current environment is one of the given environments, false otherwise
 */
export const isEnvMode = (envs: ENV['MODE'][]) => {
  const currentEnv = import.meta.env.MODE as ENV['MODE'];
  return envs.includes(currentEnv);
};
